module.exports = __webpack_public_path__ + "media/images/details__prizeBox__event__first-3e37efe0b6013c41fae5e39ea63e2a90.png";